import React, { ComponentProps } from 'react';
import { murmurhash } from '../../lib/js/hash';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { BlogPostSiblingItem } from './partials/BlogPostSiblingItem';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useWidgetHeaderId } from '../../_lib/components/Widget';

type BlogPostSiblings = {
  items: BlogPostSiblingItem[];
};

export function BlogPostSiblings({ items }: BlogPostSiblings) {
  const { t } = useSonTranslation('Blogs');
  const widgetHeaderId = useWidgetHeaderId();
  if (items && items.length > 0) {
    return (
      <nav aria-labelledby={widgetHeaderId} className="blog-post-siblings__nav">
        <ContentList>
          {items.map(item => (
            <ContentListItem key={murmurhash(item)}>
              <BlogPostSiblingItem {...item} />
            </ContentListItem>
          ))}
        </ContentList>
      </nav>
    );
  }
  return <ContentMessage text={t('siblings.noPosts')} />;
}

export const BlogPostSiblingsBlock = asBlock(BlogPostSiblings, BlockType.blogpostsiblings);
export type BlogPostSiblingsBlock = ComponentProps<typeof BlogPostSiblingsBlock>;
